import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { RoomEvent } from 'livekit-client'

import { useRoomContext } from '@/src/context'
import { TrackSource } from 'livekit-server-sdk'

export function useParticipantPermissionsNotification() {
  const room = useRoomContext()
  const { t } = useTranslation()
  const previousCanPublishMicrophone = useRef<boolean | undefined>(undefined)

  useEffect(() => {
    const handlePermissionsChanged = () => {
      const localParticipant = room.localParticipant
      const canPublishSources = localParticipant.permissions?.canPublishSources
      const canPublishMicrophone =
        !canPublishSources?.length || canPublishSources.some((source) => source === TrackSource.MICROPHONE)

      if (previousCanPublishMicrophone.current === undefined) {
        previousCanPublishMicrophone.current = canPublishMicrophone
        return
      }

      if (previousCanPublishMicrophone.current !== canPublishMicrophone) {
        if (canPublishMicrophone === false) {
          toast.info(t('micBlockedByAdmin'), {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            theme: 'dark',
          })
        }

        previousCanPublishMicrophone.current = canPublishMicrophone
      }
    }

    room.on(RoomEvent.ParticipantPermissionsChanged, handlePermissionsChanged)

    return () => {
      room.off(RoomEvent.ParticipantPermissionsChanged, handlePermissionsChanged)
    }
  }, [room, t])
}

